import service from '../service.js'

export default {

    getDivision(){
      return service.get('division')
    },
    addDivision(division, abbr, rc_code, status){
        return service.post('division',{
            division : division,
            abbr     : abbr,
            rc_code  : rc_code,
            status   : status
        })
    },
    editDivision(div_code, division, abbr, rc_code, status){
        return service.put('division',{
            div_code : div_code,
            division : division,
            abbr     : abbr,
            rc_code  : rc_code,
            status   : status
        })
    },
}